import IconInsiderStar from "../../assets/icons/v2/insider-star.webp";
import IconMapPinPublic from "../../assets/icons/v2/map-pin-public.webp";
import IconMapPinSeeded from "../../assets/icons/v2/map-pin-seeded.webp";
import IconShovelDig from "../../assets/icons/v2/shovel-dig.webp";
import IconTimeCapsuleClosed from "../../assets/icons/v2/time-capsule-closed.webp";
import IconTimeCapsuleLocked from "../../assets/icons/v2/time-capsule-locked.webp";
import IconTimeCapsuleMemory from "../../assets/icons/v2/time-capsule-memory.webp";
import IconTreasureBoxLocked from "../../assets/icons/v2/treasure-box-locked.webp";
import IconTreasureBoxUnlocked from "../../assets/icons/v2/treasure-box-unlocked.webp";

export const onboardingSlides = [
  {
    id: "find-anywhere",
    eyebrow: "FIND anywhere",
    title: "Plan anywhere you want to go.",
    body: "Ask for ideas near you or across the world, from a weekend abroad to a free afternoon downtown.",
    cardIcon: IconMapPinSeeded,
    mapMarkers: [
      { src: IconMapPinPublic, left: "23%", top: "28%", delay: "0s" },
      { src: IconTimeCapsuleClosed, left: "70%", top: "26%", delay: ".25s" },
      { src: IconMapPinSeeded, left: "50%", top: "53%", delay: ".5s" },
    ],
    accent: "#56C372",
    exampleLabel: "Try asking",
    examples: [
      "What should I do in Lisbon?",
      "Plan a rainy day in Seattle",
      "Best coffee in Mexico City",
      "Fun afternoon in Austin",
    ],
    mapCaption: "FIND helps with nearby ideas and trips abroad.",
  },
  {
    id: "explore",
    eyebrow: "Community gems",
    title: "Follow trusted friends and local places.",
    body: "Open the map or Gems to discover time capsules from friends, businesses, and places worth remembering.",
    cardIcon: IconInsiderStar,
    mapMarkers: [
      { src: IconInsiderStar, left: "24%", top: "28%", delay: "0s" },
      { src: IconMapPinSeeded, left: "70%", top: "27%", delay: ".25s" },
      { src: IconTimeCapsuleClosed, left: "50%", top: "54%", delay: ".5s" },
    ],
    accent: "#EAB016",
    exampleLabel: "Explore",
    examples: [
      "Friend-recommended gems",
      "Nearby time capsules",
      "Favorite local places",
      "Hidden gems around you",
    ],
    mapCaption: "Time capsules can come from friends, businesses, and local places.",
  },
  {
    id: "offers",
    eyebrow: "Local rewards",
    title: "Find offers from local places.",
    body: "Businesses can leave time capsules with offers, deals, raffles, and rewards for you to discover on the map and in Gems.",
    cardIcon: IconTreasureBoxUnlocked,
    mapMarkers: [
      { src: IconInsiderStar, left: "24%", top: "28%", delay: "0s" },
      { src: IconTreasureBoxLocked, left: "70%", top: "27%", delay: ".25s" },
      { src: IconTreasureBoxUnlocked, left: "50%", top: "54%", delay: ".5s" },
    ],
    accent: "#EAB016",
    exampleLabel: "Look for",
    examples: [
      "Local offers in Gems",
      "Nearby raffles",
      "Rewards from local places",
      "Deals on the map",
    ],
    mapCaption: "Time capsules can hold offers, rewards, raffles, and deals.",
  },
  {
    id: "bury",
    eyebrow: "BURY memories",
    title: "Leave something meaningful behind.",
    body: "Create time capsules tied to real places, then let friends or your future self discover them later.",
    cardIcon: IconShovelDig,
    mapMarkers: [
      { src: IconTimeCapsuleMemory, left: "24%", top: "28%", delay: "0s" },
      { src: IconTimeCapsuleLocked, left: "70%", top: "27%", delay: ".25s" },
      { src: IconTimeCapsuleClosed, left: "50%", top: "54%", delay: ".5s" },
    ],
    accent: "#1152E4",
    exampleLabel: "Create",
    examples: [
      "A birthday memory",
      "A surprise at dinner",
      "A trip highlight",
      "A place-based note",
    ],
    mapCaption: "Time capsules can be memories, stories, offers, or rewards.",
  },
];
